/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText } from '@powdr/constants';

export const SubaruVipForm = ({
  captchaSiteKeyBasin,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
}) => {
  const captchaRef = useRef();
  return (
    <form
      onSubmit={(e) => processForm(e, 'df743626502e', null, captchaRef)}
      id="subaru-vip-form"
    >

      <label className="input-label">
        First Name *
        <input
          name="First Name"
          id="first-name"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        Last Name *
        <input
          name="Last Name"
          id="last-name"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        Email address *
        <input
          name="Email"
          id="email"
          className="form-control"
          type="email"
          required
        />
      </label>

      <label className="input-label">
        Pass Number
        <input
          name="Pass Number"
          id="pass-number"
          className="form-control"
          type="text"
        />
      </label>

      <label className="input-label">
        Home Mailing Address *
        <input
          name="Mailing Address"
          id="mailing-address"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        City *
        <input
          name="City"
          id="city"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        State *
        <select className="form-control" id="state" name="state" required>
          <option value="" selected="selected">- select a state -</option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AB">Alberta</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="BC">British Columbia</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MB">Manitoba</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NB">New Brunswick</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NL">Newfoundland and Labrador</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="NT">Northwest Territories</option>
          <option value="NS">Nova Scotia</option>
          <option value="NU">Nunavut</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="ON">Ontario</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="PE">Prince Edward Island</option>
          <option value="QC">Quebec</option>
          <option value="RI">Rhode Island</option>
          <option value="SK">Saskatchewan</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
          <option value="YT">Yukon</option>
        </select>
      </label>

      <label className="input-label">
        Zip Code *
        <input
          name="Zip Code"
          id="zipcode"
          className="form-control"
          type="number"
          required
        />
      </label>

      <label className="input-label">
        Daytime Phone Number *
        <input
          name="Phone Number"
          id="phone-number"
          className="form-control"
          type="tel"
          required
        />
      </label>

      <label className="input-label">
        Preferred Vehicle Model
        <select className="form-control" id="preferred-vehicle" name="Preferred Vehicle Model" required>
          <option value="">Undecided</option>
          <option value="Ascent">Ascent</option>
          <option value="BRZ (excludes 2024 BRZ tS)">BRZ (excludes 2024 BRZ tS)</option>
          <option value="Crosstrek">Crosstrek</option>
          <option value="Forester">Forester</option>
          <option value="Impreza">Impreza</option>
          <option value="Legacy">Legacy</option>
          <option value="Outback">Outback</option>
          <option value="Solterra">Solterra</option>
          <option value="WRX (excludes 2024 WRX TR)">WRX (excludes 2024 WRX TR)</option>
        </select>
      </label>

      <h3>Choice of Participating Dealer</h3>
      <p>
        Look up dealers in your area on Subaru's website:
        {' '}
        <br />
        <a href="https://www.subaru.com/find-retailer/index.html">https://www.subaru.com/find-retailer/index.html</a>
      </p>
      <br />
      <p>
        If a dealer is not specified, Subaru of America will select the closest participating dealer based on your zip code.
      </p>
      <input
        name="Choice of Participating Dealer"
        id="choice-of-participating-dealer"
        className="form-control"
        type="text"
        required
      />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={captchaSiteKeyBasin}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>{buttonText || ButtonText.SUBMIT}</button>
    </form>
  );
};

SubaruVipForm.propTypes = {
  captchaSiteKeyBasin: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
